module.exports = __webpack_public_path__ + "img/Prudential_logo.b1fe28aa.png";